import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=8f2913ac&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2913ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f2913ac')) {
      api.createRecord('8f2913ac', component.options)
    } else {
      api.reload('8f2913ac', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=8f2913ac&scoped=true&", function () {
      api.rerender('8f2913ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fnh8Ndvy0N7K/JS/comp/SearchFilterTokens.vue"
export default component.exports